import React from "react";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
const LayoutModal = props => {
  const { route, path, lang, server, match } = props;
  return (
    <div className="layout-modal">
      <Placeholder name="jss-main" rendering={route} pathname={path} lang={lang} page={route} match={match} server={server} />
    </div>
  );
};
export default LayoutModal;
